import { createAsyncThunk } from '@reduxjs/toolkit';
import type { DefaultThunkConfig } from '@/app/providers/storeProvider';
import type { AxiosError } from 'axios';
import { cookieHelper, CookieKeyEnum } from '@/app/cookies';
import type { AppAxiosErrorPayload } from '@/z-shared/api';
import type { AvailableToResendAt } from '../types/resendEmailCodeSchema';
import { EmailValidationRequest } from '../../lib/const/emailValidationRequestType';

interface ResendEmailCodeProps {
    type: EmailValidationRequest;
    email?: string;
}

export const resendEmailCode = createAsyncThunk<AvailableToResendAt, ResendEmailCodeProps, DefaultThunkConfig>(
    'resendEmailCode',
    async ({ email, type }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;

        try {
            const { data } = await (() => {
                switch (type) {
                    case EmailValidationRequest.ACTIVATE_USER:
                    case EmailValidationRequest.FORGOT_PASSWORD:
                        return extra.api.post<AvailableToResendAt>(`/auth/${type}`, { email });
                    case EmailValidationRequest.DELETE_USER:
                        return extra.api.delete<AvailableToResendAt>(`/${type}`);
                }
            })();

            cookieHelper.set(CookieKeyEnum.NEXT_CODE_RESEND_DATE, data.availableToResendAt);

            return data;
        }
        catch (e) {
            const error = e as AxiosError<AppAxiosErrorPayload>;
            return rejectWithValue(error.response?.data);
        }
    },
);
